import { Theme, darken, lighten } from "@mui/material";
import { RFC_PFAE, RFC_PM } from "@utils/expreciones";

/** Formato corto del diseño (`fxM`): `$1.5M`, `$750k`, `$0`. */
export const formatShort = (amount: number) => {
  if (!amount) return "$0";
  if (amount >= 1_000_000) return `$${(amount / 1_000_000).toFixed(amount % 1_000_000 === 0 ? 0 : 1)}M`;
  return `$${Math.round(amount / 1000).toLocaleString("en-US")}k`;
};

/** Convierte lo tecleado en un monto: descarta todo lo que no sea dígito. */
export const digitsToNumber = (value: string) => Number(value.replace(/[^0-9]/g, "")) || 0;

/**
 * Colores de los segmentos de cada empresa (`FXU_COLORS` del diseño), derivados de la paleta del
 * tenant para que la barra y el chip de cada fila usen el mismo color.
 */
export const getSegmentColor = (theme: Theme, index: number) => {
  const { main, accent, base, hover } = theme.palette.primary;
  const { tokens } = theme.palette;
  // Flux: #253F3A, #3A5C54 (`neutrals.borderHover`), #81AB77, ≈#B5CEAF, #172D29 (`hover`), #CFE1CB (`neutrals.infoBorder`).
  const colors = [
    main,
    tokens?.borderHover ?? lighten(main, 0.15),
    accent,
    lighten(accent, 0.35),
    hover ?? darken(main, 0.3),
    tokens?.infoBorder ?? base,
  ];
  return colors[index % colors.length];
};

/**
 * Error del RFC de una empresa con la que se va a operar. Es opcional: vacío no es error. Si se captura, debe ser
 * de persona moral (12 posiciones, `RFC_PM`) o de PFAE (13, `RFC_PFAE`). Primero la longitud y luego el formato,
 * para que cada caso tenga su mensaje.
 */
export const getRfcEmpresaError = (rfc: string): string => {
  const value = rfc.trim();
  if (!value) return "";
  if (value.length !== 12 && value.length !== 13) return "Debe tener 12 o 13 posiciones";
  const regex = value.length === 12 ? RFC_PM : RFC_PFAE;
  if (!regex.test(value)) return "RFC incorrecto";
  return "";
};
